import React, { createContext, FC, memo, ReactNode, useContext, useState } from 'react';

import { TimesheetSelected } from 'src/features/timesheets/TimesheetGrid/TimesheetGrid.types';

type TimesheetSelectionProps = {
  selected: TimesheetSelected | undefined;
  onSelect: (selected: TimesheetSelected) => void;
  onClear: () => void;
};

const TimesheetSelectionContext = createContext<TimesheetSelectionProps>({} as TimesheetSelectionProps);

export const useTimesheetSelection = (): TimesheetSelectionProps =>
  useContext<TimesheetSelectionProps>(TimesheetSelectionContext);

export const TimesheetSelectionProvider: FC<{ children: ReactNode }> = memo(({ children }) => {
  const [selected, setSelected] = useState<TimesheetSelected>();

  const handleSelect = (selected: TimesheetSelected) => {
    setSelected(selected);
  };

  const handleClear = () => {
    setSelected(undefined);
  };

  return (
    <TimesheetSelectionContext.Provider value={{ selected, onSelect: handleSelect, onClear: handleClear }}>
      {children}
    </TimesheetSelectionContext.Provider>
  );
});
